import { Annotation } from "@/types";
import { AnnotationApi } from "./interface";
import { ApiHooksProps } from "../interface";
import { request } from "../request";
import { useCallback } from "react";

const hook = ({ setError, setLoading, setSuccess, serverPath, token }: ApiHooksProps): AnnotationApi => {
    const createAnnotation = useCallback(async (body: Annotation) => {
        const path = `${serverPath}/annotations/create`;
        setLoading(true);
        try {
            await request(path, { body, token });
            setSuccess('Annotation created')
        } catch (error: unknown) {
            if (typeof error === 'string') {
              setError(error);
            }
            else if (error instanceof Error) {
              setError(error.message || '');
            }
        }
        setLoading(false);

        return;
    }, [serverPath, token]);

    const deleteAnnotation = useCallback(async (annotationId: string) => {
        const path = `${serverPath}/annotations/delete/${annotationId}`;
        setLoading(true);
        try {
            await request(path, { token });
            setSuccess('Annotation deleted')
        } catch (error: unknown) {
            if (typeof error === 'string') {
              setError(error);
            }
            else if (error instanceof Error) {
              setError(error.message || '');
            }
        }
        setLoading(false);

        return;
    }, [serverPath, token]);

    const getAnnotations = useCallback(async (uploadFileId: string) => {
        const path = `${serverPath}/annotations/get/${uploadFileId}`;
        const res = await request<never, Annotation[]>(path, { method: 'GET', token });

        return res;
    }, [serverPath, token]);

    const updateAnnotation = useCallback(async (body: Annotation) => {
        const path = `${serverPath}/annotations/update`;
        setLoading(true);
        try {
            await request(path, { body, token });
            setSuccess('Annotation updated!')
        } catch (error: unknown) {
            if (typeof error === 'string') {
              setError(error);
            }
            else if (error instanceof Error) {
              setError(error.message || '');
            }
        }
        setLoading(false);

        return;
    }, [serverPath, token]);

    return {
        createAnnotation,
        deleteAnnotation,
        getAnnotations,
        updateAnnotation
    }
}

export default hook;